// extracted by mini-css-extract-plugin
export var isCompact = "_TD4I";
export var spinner = "x3R_q";
export var spinnerCircle = "eTOzK";